
import { getOrderId } from '@/utils/getOrderId'

/**
 * orderList - мутабельный
 */

export const setRouteTaskToList = (orderList, {
      orderIds,
      routeTaskId,
      allowedByFootCourier,
      // может быть route_task_id
      idField = 'id',
      approvedByAdmin = true
    }
  ) => {
    orderList.forEach(o => {
      if (orderIds.find(id => id === getOrderId(o)) !== undefined) {
        o.route_task = {
          [idField]: routeTaskId,
          approved_by_admin: approvedByAdmin,
          allowed_by_foot_courier: allowedByFootCourier
        }
      }
    })
}

/**
 * orderIds - это список заказов в МЗ,
 * orderList - мутабельный
 */
export const unsetRouteTaskFromList = (orderList, orderIds) => {
  orderList.forEach(o => {
    if (orderIds.find(id => id === getOrderId(o)) !== undefined) {
      o.route_task = null
    }
  })
}
